module.exports = __webpack_public_path__ + "img/banner2.d69c3ffe.jpg";